"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyledMenuList = _styledComponents["default"].div.withConfig({
  displayName: "MenuListstyle__StyledMenuList",
  componentId: "sc-v4wiix-0"
})(["", ";"], function (props) {
  var palette = props.theme.palette;
  var isExpanded = props.isExpanded,
    position = props.position;
  var positioningProps;
  switch (position) {
    case 'top-left':
      positioningProps = {
        box: (0, _styledComponents.css)(["left:50%;top:50%;"]),
        close: (0, _styledComponents.css)(["left:0;transform:translate(-50%,-50%);"])
      };
      break;
    case 'bottom-left':
      positioningProps = {
        box: (0, _styledComponents.css)(["left:50%;bottom:0%;"]),
        close: (0, _styledComponents.css)(["left:0;bottom:0;transform:translate(-50%,50%);"])
      };
      break;
    case 'bottom-right':
      positioningProps = {
        box: (0, _styledComponents.css)(["right:50%;bottom:0%;"]),
        close: (0, _styledComponents.css)(["right:0;bottom:0;transform:translate(50%,50%);"])
      };
      break;
    case 'top-right':
    default:
      positioningProps = {
        box: (0, _styledComponents.css)(["right:10px;top:50%;"]),
        close: (0, _styledComponents.css)(["right:50%;top:50%;transform:translate(50%,-50%);"])
      };
      break;
  }
  return (0, _styledComponents.css)(["position:relative;float:right;.content-toggler{cursor:pointer;display:inline-block;width:10px;text-align:center;line-height:1;i{font-size:24px;}}.single-list-item{color:", ";cursor:pointer;&.:not(.icon-label){text-decoration:underline;}&.disabled{pointer-events:none;cursor:not-allowed;color:", ";}}.list-container{position:absolute;z-index:99;", ";}", " .close-button{cursor:pointer;color:", ";display:inline-block;line-height:1;z-index:100;}"], palette.secondary, palette.gray.charlie, positioningProps.box, isExpanded && (0, _styledComponents.css)([".close-button{position:absolute;z-index:4;", " width:20px;}"], positioningProps.close), palette.primary);
});
StyledMenuList.displayName = 'StyledMenuList';
var _default = exports["default"] = StyledMenuList;